import { useCallback } from 'react';

/**
 * A custom hook that generates a test ID string for a given component.
 *
 * @param componentName - The name of the component to be used as the base for the test ID.
 * @returns A function that builds a test ID string by concatenating the component name
 *          with additional arguments, separated by hyphens. Undefined or falsy values
 *          in the arguments are filtered out.
 *
 * @example
 * const buildTestId = useTestId('DealGPTButton');
 * const testId = buildTestId('primary', 1); // Returns 'DealGPTButton-primary-1'
 */
export const useTestId = (componentName: string) => {
  const buildTestId = useCallback(
    (...args: (string | number | undefined)[]) => {
      return [componentName, ...args.filter(Boolean)].join('-');
    },
    [componentName]
  );

  return buildTestId;
};
